export default __webpack_public_path__ + "static/media/validation.6dc4ff9f.svg";